import {ChangeDetectorRef, Component, forwardRef, OnInit} from '@angular/core';
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {StickerFormat} from "../../../shared/view-model/store-management/sticker-format.type";
import {SessionActions} from "../../../shared/actions";

export const STICKER_PLACEHOLDERS: { [placeholder: string]: string } = {
  '%N': 'Handelsname des Medikaments (z.B. Cordarex)',
  '%S': 'Wirkstoffname des Medikaments (z.B. Amiodaron)',
  '%W': 'Die gesamte Wirkstoffmenge in dem Medikament (z.B. 150)',
  '%w': 'Die Wirkstoffmenge umgerechnet auf 1 Inhalts-Einheit (z.B. 50)',
  '%EW': 'Die Einheit der Wirkstoffangabe (z.B. mg)',
  '%I': 'Die gesamte Inhaltsmenge des Medikaments (inkl. Wirkstoff, Trägersubstanzen und sonstiger Substanzen, z.B. 3)',
  '%EI': 'Die Einheit der Inhaltsmengenangabe (z.B. ml)',
};

@Component({
  selector: 'vb-sticker-format-form',
  templateUrl: './sticker-format-form.component.html',
  styleUrls: ['./sticker-format-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => StickerFormatFormComponent)}]
})
export class StickerFormatFormComponent extends AbstractVisbosControl<StickerFormat, FormGroup> implements OnInit {

  placeholderDefinitions;
  showHelp: boolean = false;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
    this.placeholderDefinitions = STICKER_PLACEHOLDERS;
  }


  ngOnInit(): void {
    super.ngOnInit();
  }

  buildControlContent(values?: StickerFormat): FormGroup {
    return StickerFormatFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder): FormGroup {
    return fb.group({
      cuid: [null],
      administration_unit_id: [null, Validators.required],
      label: [null, Validators.required],
      substance_string: [null, Validators.required],
      dosage_string: [null, Validators.required],
      dosage_only_string: [null, Validators.required],
      no_dosage_string: [null, Validators.required],
      color_mode: [null, Validators.required],
    });
  }

  public setDefaultValues(item?: StickerFormat): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      administration_unit_id: this.setValue(item, 'administration_unit_id', this.activeAdminUnitCuid),
      label: this.setValue(item, 'label'),
      substance_string: this.setValue(item, 'substance_string'),
      dosage_string: this.setValue(item, 'dosage_string'),
      dosage_only_string: this.setValue(item, 'dosage_only_string'),
      no_dosage_string: this.setValue(item, 'no_dosage_string'),
      color_mode: this.setValue(item, 'color_mode', 'CMYK'),
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/components/sticker-format-form/sticker-format-form.component.ts